import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CharactersPage = lazy(() => import('../pages/characters/page'));
const HaeonEditionsPage = lazy(() => import('../pages/characters/haeon-editions/page'));
const SolEditionsPage = lazy(() => import('../pages/characters/sol-editions/page'));
const DoriEditionsPage = lazy(() => import('../pages/characters/dori-editions/page'));
const PaliEditionsPage = lazy(() => import('../pages/characters/pali-editions/page'));
const StorybookPage = lazy(() => import('../pages/storybook/page'));
const StorybookChildrenPage = lazy(() => import('../pages/storybook/children/page'));
const GoodsPage = lazy(() => import('../pages/goods/page'));
const GoodsDetailPage = lazy(() => import('../pages/goods/detail/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const MetaversePage = lazy(() => import('../pages/metaverse/page'));
const ARExperiencePage = lazy(() => import('../pages/ar-experience/page'));
const NFTGalleryPage = lazy(() => import('../pages/nft-gallery/page'));
const LoginPage = lazy(() => import('../pages/auth/login/page'));
const SignupPage = lazy(() => import('../pages/auth/signup/page'));
const MyPage = lazy(() => import('../pages/mypage/page'));
const InteractiveArtPage = lazy(() => import('../pages/interactive-art/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/characters',
    element: <CharactersPage />,
  },
  {
    path: '/characters/haeon-editions',
    element: <HaeonEditionsPage />,
  },
  {
    path: '/characters/sol-editions',
    element: <SolEditionsPage />,
  },
  {
    path: '/characters/dori-editions',
    element: <DoriEditionsPage />,
  },
  {
    path: '/characters/pali-editions',
    element: <PaliEditionsPage />,
  },
  {
    path: '/storybook',
    element: <StorybookPage />,
  },
  {
    path: '/storybook/:id',
    element: <StorybookChildrenPage />,
  },
  {
    path: '/goods',
    element: <GoodsPage />,
  },
  {
    path: '/goods/:id',
    element: <GoodsDetailPage />,
  },
  {
    path: '/goods/detail/:id',
    element: <GoodsDetailPage />,
  },
  {
    path: '/cart',
    element: <CartPage />,
  },
  {
    path: '/metaverse',
    element: <MetaversePage />,
  },
  {
    path: '/ar-experience',
    element: <ARExperiencePage />,
  },
  {
    path: '/nft-gallery',
    element: <NFTGalleryPage />,
  },
  {
    path: '/interactive-art',
    element: <InteractiveArtPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignupPage />,
  },
  {
    path: '/mypage',
    element: <MyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
